const update = (selector, html) => {
	const element = document.querySelector(selector)

	if (element !== undefined) {
		element.innerHTML = html
	}
}

/**
 * @param   {string} htmlString - Element to be created
 * @param   {string} element    - Tag to create
 * @returns {Html}              - Created element
 */
function createHtmlElement(htmlString, element) {
	var div = document.createElement(element)
	div.innerHTML = htmlString.trim()

	return div.firstChild
}

/**
 * Promise function that waits until element has loaded until rest of code is run.
 * @param {Array} selectors - Selectors you want to check. Ex: '.class-1, .class-2 [data-attribute]'
 */
function elementReady(selector) {
	return new Promise(resolve => {
		// convert NodeList to Array
		const elements = [...document.querySelectorAll(selector)]

		if (elements?.length) {
			elements.forEach(element => {
				// Found element, lets resolve so the rest of the code can run
				resolve(element)
			})
		}

		// Element is not ready, lets observe for changes. If found, resolve and continue.
        new MutationObserver((_, observer) => {
            // This code block will be executed on observed changes of the element passed 
            // in to this MutationObserver. 
            // For our use that element is the document.documentElement in the .observe callback

			Array.from(document.querySelectorAll(selector)).forEach(el => {
				// Resolve element when it exists
				resolve(el)

				// disconnect observer after the element was found
				observer.disconnect()
			})
		}).observe(document.documentElement, {
			childList: true,
			subtree: true,
		})
	})
}

export { update, elementReady, createHtmlElement }
